<!-- Body -->
<div class="ui basic segment">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <deprecated-app-task-template-form
                    #taskTemplateForm
                    [taskTemplate]="taskTemplate"
                ></deprecated-app-task-template-form>
            </div>
            <div class="action-buttons">
                <ui-button (click)="cancel($event)"> Cancel </ui-button>
                <ui-button (click)="save(taskTemplateForm)" type="primary"> Save </ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3 class="text-color">Global Tasks</h3>
                <p>This task will be saved as a template and can be changed at anytime.</p>
                <p>A due date is not required but is recommended</p>
                <p>
                    <a
                        (click)="
                            analytics.logLinkOpen(
                                'https://humi.zendesk.com/hc/en-us/articles/360047402853',
                                events.OnboardingTaskLearnMore
                            )
                        "
                        >Learn more</a
                    >
                    about tasks.
                </p>
            </div>
        </div>
    </div>
</div>
